import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { MerchantPageDocument } from './graphql/merchantPage.gql';

export const useMerchantPageQuery = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error('companyProfileId is undefined in useMerchantAccount');
  }

  const { data, ...hook } = useQuery(MerchantPageDocument, {
    variables: {
      companyProfileId,
    },
  });

  return {
    merchantAccount: data?.viewer.company.merchantAccount ?? null,
    ...hook,
  };
};

export type MerchantAccount = NonNullable<
  ReturnType<typeof useMerchantPageQuery>['merchantAccount']
>;
